import { render, staticRenderFns } from "./addCertificate.vue?vue&type=template&id=02ddd5f5&scoped=true&"
import script from "./addCertificate.vue?vue&type=script&lang=js&"
export * from "./addCertificate.vue?vue&type=script&lang=js&"
import style0 from "./addCertificate.vue?vue&type=style&index=0&id=02ddd5f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ddd5f5",
  null
  
)

export default component.exports